import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { MdDeleteOutline, MdOutlineRemoveRedEye } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../services/ApiService";
import { DotLoaderComp } from "../../../components/DotLoader/index";
import {
  ShowErrorToast,
  ShowSuccessToast,
} from "../../../components/toaster/toast";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { CircularProgress } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { ModalContainer } from "./ModalContainer";

export const Quotes = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [updateLoading, setUpdateLoading] = useState(false);
  const [selectUserId, setSelectUserId] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  // const [dateRange, setDateRange] = useState([null, null]);
  // const [brokerList, setBrokerList] = useState([]);
  // const [selectedBroker, setSelectedBroker] = useState("");

  useEffect(() => {
    fetchQuotes();
  }, []);

  const handleClose = () => {
    setOpen(false);
    setSelectUserId(null);
  };

  const handleDropdownChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleSaveChanges = async () => {
    try {
      setUpdateLoading(true);

      // Update the quote
      const response = await ApiService.updateQuoteByIdManagement(selectUserId, {
       status: selectedStatus,
      });
console.log(response)
      // Fetch updated data and set it to the state
      await fetchQuotes(); // Call the shared fetch function

      ShowSuccessToast("Quote updated successfully!");
      handleClose();
    } catch (error) {
      ShowErrorToast("Failed to update quote.");
      console.error("Error updating quote:", error);
    } finally {
      setUpdateLoading(false);
    }
  };

  const fetchQuotes = async () => {
    setLoading(true);
    try {
      const response = await ApiService.getQuotesManagement();
      const data = response.data.map(item => ({
        ...item,
        full_name: `${item.first_name} ${item.last_name}` // Create full_name field
      }));
      setRows(data);
      console.log(response.data);
      setFilteredRows(data);
    } catch (error) {
      ShowErrorToast("Failed to fetch quotes.");
      console.error("Error fetching quotes:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const filtered = rows.filter((row) => {
      const term = searchTerm.toLowerCase();
      return (
        // row.broker_info?.toLowerCase().includes(term) ||
        dayjs(row.date)?.format("DD-MM-YYYY").includes(term)  ||
          // row.first_name?.toLowerCase().includes(term) ||
          // row.last_name?.toLowerCase().includes(term) ||
          row.full_name?.toLowerCase().includes(term) ||
          Array.isArray(JSON.parse(row.members || "[]"))
          ? JSON.parse(row.members || "[]").length
          : "N/A".toString().includes(term) ||
              row.email?.toLowerCase().includes(term) ||
              row.status?.toLowerCase().includes(term)
      );
    });

    setFilteredRows(filtered);
  }, [searchTerm, rows]);

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this quote?"
    );
    if (!isConfirmed) return;

    setLoading(true);
    try {
      await ApiService.deleteQuoteByIdManagement(id);
      ShowSuccessToast("Quote deleted successfully!");
      setRows((prevRows) => prevRows.filter((row) => row.id !== id));
    } catch (error) {
      ShowErrorToast("Failed to delete Quote.");
      console.error("Error deleting Quote:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleView = (row) => {
    navigate(`/view-quote/${row.id}`);
  };

  useEffect(() => {
    const filtered = rows.filter((row) => {
      const term = searchTerm.toLowerCase();
      return (
        row.full_name?.toLowerCase().includes(term) ||
        row.email?.toLowerCase().includes(term)
      );
    });
    setFilteredRows(filtered);
  }, [searchTerm, rows]);
  

  const handleSelectionChange = (selection) => {
    setSelectedRows(selection);
  };

  // Export Selected Rows (Excluding `full_name`)
  const handleExportCSV = () => {
    if (!selectedRows.length) {
      ShowErrorToast("No rows selected for export.");
      return;
    }
  
    const selectedData = rows.filter((row) => selectedRows.includes(row.id));
  
    if (!selectedData.length) return;
  
    const keys = Object.keys(selectedData[0]).filter((key) => key !== "full_name"); // Exclude full_name
    let csvContent = keys.join(",") + "\n";
  
    selectedData.forEach((row) => {
      const rowArray = keys.map((key) => {
        let cell = row[key];
  
        // Format date if key is "date"
        if (key === "date" && cell) {
          cell = dayjs(cell).format("DD-MM-YYYY");
        } else if (cell !== null && cell !== undefined) {
          cell = cell.toString();
        } else {
          cell = "";
        }
  
        // Escape commas by wrapping in quotes if necessary
        if (cell.includes(",")) {
          cell = `"${cell}"`;
        }
  
        return cell;
      });
  
      csvContent += rowArray.join(",") + "\n";
    });
  
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "quotes.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  

  const columns = [
    // { field: "broker_info", headerName: "Broker Info", minWidth: 130, flex: 1 },
    { field: "full_name", headerName: "Full Name", minWidth: 200, flex: 1 }, // Display full_name
      // { field: "first_name", headerName: "First Name", minWidth: 150, flex: 1 },
      // { field: "last_name", headerName: "Last Name", minWidth: 150, flex: 1 },
    {
      field: "date",
      headerName: "Date",
      minWidth: 120,
      flex: 1,
      renderCell: (params) => dayjs(params.value).format("DD-MM-YYYY"),
    },
    // { field: "full_name", headerName: "Full Name", minWidth: 200, flex: 1, valueGetter: (params) => `${params.row.first_name} ${params.row.last_name}` },
    {
      field: "members",
      headerName: "Members",
      minWidth: 120,
      flex: 1,
      renderCell: (params) => {
        try {
          const membersArr = JSON.parse(params.value || "[]");
          return membersArr.length;
        } catch (error) {
          return "N/A";
        }
      },
    },
    { field: "email", headerName: "Email", minWidth: 200, flex: 1 },
    {
      field: "status",
      headerName: "Status",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        const getBadgeClass = (status) => {
          switch (status) {
            case "Policy Issued":
              return "bg-teal-100 text-teal-700 border border-teal-500";
            case "Downloaded":
              return "bg-gray-200 text-gray-700 border border-gray-500";
            case "Contacted":
              return "bg-yellow-100 text-yellow-800 border border-yellow-600";
            case "Application Sent":
              return "bg-purple-100 text-purple-800 border border-purple-600";
            case "Received":
              return "bg-green-100 text-green-700 border border-green-500";
            case "Submitted":
              return "bg-orange-100 text-orange-800 border border-orange-600";
            case "Declined":
              return "bg-red-100 text-red-700 border border-red-600";
            case "Accepted":
              return "bg-blue-100 text-blue-700 border border-blue-500";
            default:
              return "bg-transparent";
          }
        };

        const status = params.row.status || "Submitted";
        return (
          <span
            className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${getBadgeClass(
              status
            )}`}
          >
            {status}
          </span>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 140,
      flex: 0.5,
      renderCell: (params) => (
        <div className="flex items-center gap-3 mt-3">
          <MdOutlineRemoveRedEye
            size={21}
            className="cursor-pointer text-[#008767]"
            onClick={() => handleView(params.row)}
          />
          <FaRegEdit
            size={21}
            className="cursor-pointer text-[#333547]"
            onClick={() => {
              setSelectUserId(params.row.id); // Set selected user
              setSelectedStatus(params.row.quote || "Downloaded"); // Set current status in dropdown
              setOpen(true); // Open the modal
            }}
          />
          <MdDeleteOutline
            size={24}
            className="cursor-pointer text-[#EE1919]"
            onClick={() => handleDelete(params.row.id)}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <ModalContainer open={open} handleClose={handleClose}>
        {/* Modal content for editing quotes */}
        <div className="bg-white rounded-lg shadow-lg w-[450px] h-[450px] flex flex-col">
          <div className="px-6 py-4 flex justify-between items-center">
            <h5 className="text-2xl font-semibold">Edit Quote</h5>
            <IoMdClose
              className="text-2xl cursor-pointer"
              onClick={handleClose}
            />
          </div>

          <div className="p-6 flex-grow">
            <form className="h-full flex flex-col justify-between">
              <div className="mb-4">
                <label
                  htmlFor="statusSelect"
                  className="block text-sm font-normal text-gray-700"
                >
                  Status
                </label>
                <select
                  id="statusSelect"
                  name="statusSelect"
                  className="mt-1 block p-2 outline-none w-full border border-gray-300 rounded-md shadow-sm bg-[#F0F0F0] sm:text-sm"
                  value={selectedStatus}
                  onChange={handleDropdownChange}
                  style={{ lineHeight: "2.5rem" }}
                >
                  <option value="Submitted">Submitted</option>
                  <option value="Downloaded">Downloaded</option>
                  <option value="Policy Issued">Policy Issued</option>
                  <option value="Contacted">Contacted</option>
                  <option value="Application Sent">Application Sent</option>
                  <option value="Received">Received</option>
                  <option value="Declined">Declined</option>
                  <option value="Accepted">Accepted</option>
                </select>
              </div>
              <button
                type="button"
                className={`mt-3 py-2 px-4  border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-orangeColor hover:bg-orangeColor focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 ${
                  updateLoading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                onClick={handleSaveChanges}
                disabled={updateLoading}
              >
                {updateLoading ? (
                  <CircularProgress size={24} />
                ) : (
                  "Save Changes"
                )}
              </button>
            </form>
          </div>
        </div>
      </ModalContainer>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="bg-[#F9F8F5] px-10 py-3">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-semibold text-[#012949]">Quotes Management</h1>
          </div>
          <div className="flex justify-between mb-4 gap-4">
              {/* <input
                type="text"
                placeholder="Search..."
                className="border p-2 rounded"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              /> */}
                    <div className="relative">
          <div className="absolute inset-y-0 start-0 flex justify-center items-center ps-3 pointer-events-none">
            <svg className="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
            </svg>
          </div>
          <input
            type="search"
            id="default-search"
            className="block w-full sm:w-[300px] md:w-[400px] lg:w-[500px] h-[40px] p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-full bg-gray-50 outline-none"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
              <button
                onClick={handleExportCSV}
                className="px-4 py-2 bg-orangeColor rounded-[8px] font-inter text-base font-bold text-white"
              >
                Export CSV
              </button>
            </div>
          {loading ? (
            <div className="h-[70vh] flex items-center justify-center">
              <DotLoaderComp />
            </div>
          ) : (
            <div className="h-[400px] bg-white">
              <DataGrid
                pageSize={10}
                rowsPerPageOptions={[10]}
                rows={filteredRows}
                columns={columns}
                checkboxSelection
                onRowSelectionModelChange={handleSelectionChange}
              />
            </div>
          )}
        </div>
      </LocalizationProvider>
    </>
  );
};
